<template>
  <div class="form-container">
    <div class="vcore_container pe_container">
      <div class="vcore_row">
        <div class="vcore_col--xs--12 form-container_provider-logo">
          <LogoDisplay v-if="logo" :logo-src="logo"></LogoDisplay>
        </div>
        <div class="vcore_col--xs--12">
          <h2 class="form-title" tabindex="-1" v-focus="lastActivated">
            Confirm
          </h2>
          <div class="form-description">
            You’re almost there! Please review your information.
          </div>
        </div>
        <div class="vcore_col--xs--12">
          <h3 class="section_title">
            HSF<span class="sup">&reg;</span> Payment Terms Summary
          </h3>
          <PaymentEstimator :total-loan-amount="amountRequested | usdToFloat" :terms="selectedProvider.terms"
            :is-fixed-rate="selectedProvider.isFixedRate" :fixed-interest-rate="selectedProvider.fixedInterestRate"
            :rate-margin="selectedProvider.rateMargin" :step="'Confirmation'" readonly></PaymentEstimator>
        </div>

        <div v-for="group in formData.groups" v-if="evalProperty(group.showIf)" :key="group.name"
          class="vcore_col--xs--12">
          <div class="vcore_row section_header">
            <div class="vcore_col--xs--12">
              <span>{{ group.name }}</span>
              <button class="edit-button" @click="editClicked(group.name)">
                <i class="vcore_icon icon-edit"></i>
                Edit
              </button>
            </div>
          </div>
          <div class="vcore_row">
            <div v-for="column in group.columns" :key="`${group.name}${column.name}`"
              :class="[...getSizeClases(column.size), 'info-column']">
              <ConfirmationDataItem v-for="field in column.fields" v-if="formValues[group.value][field.value]"
                :key="field.name" :name="field.name" :value="formValues[group.value][field.value]"
                :filter="field.filter"></ConfirmationDataItem>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentEstimator from "@Shared/components/PaymentEstimator";
import ConfirmationDataItem from "../ConfirmationDataItem";
import ConfirmationForm from "../../forms/Confirmation.json";
import LogoDisplay from "../LogoDisplay";
import { KEYS, getCustomBrandingByKey } from "@Shared/utils/CustomBranding";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Confirmation",
  components: {
    PaymentEstimator,
    ConfirmationDataItem,
    LogoDisplay,
  },
  data() {
    return {
      formData: ConfirmationForm,
      lastActivated: "",
    };
  },
  computed: {
    ...mapGetters([
      "formValues",
      "acceptedTermsAndConditions",
      "consentToContact",
      "amountRequested",
      "physicalMailingAddressCheckbox",
      "previousAddressCheckbox",
      "selectedProvider",
    ]),
    logo() {
      return getCustomBrandingByKey(
        KEYS.LOGO,
        this.selectedProvider.customBrandingList
      );
    },
  },
  activated() {
    this.lastActivated = +new Date();
  },
  methods: {
    ...mapActions(["setTermsAndConditionsError", "submitEnrollment", "setShowFeedbackModal"]),
    evalProperty(name) {
      if (typeof this[name] === "boolean" && typeof name !== "undefined") {
        return this[name];
      } else {
        return true;
      }
    },
    editClicked(location) {
      this.$store.commit("SET_EDIT_FLAG", true);
      this.$emit("edit-click", location);
    },
    getSizeClases(sizeObj) {
      return Object.keys(sizeObj).map((x) => `vcore_col--${x}--${sizeObj[x]}`);
    },
    reset() { },
    touch() { },
    next() {
      if (this.acceptedTermsAndConditions && this.consentToContact) {
        this.submitEnrollment()
          .then(() => {
            this.setShowFeedbackModal(true);
            this.$emit("next-step");
          })
          .catch((err) => {
            console.error(err);
            this.$emit("major-error");
          });
      } else {
        this.setTermsAndConditionsError(true);
      }
    },
    previous() {
      this.$emit("prev-step");
    },
  },
};
</script>

<style lang="scss" scoped>
.sup {
  font-size: 70%;
  vertical-align: super;
}

.section_title {
  margin-top: 40px;
  margin-bottom: 25px;
}

.section_header {
  margin-top: 40px;
  margin-bottom: 25px;
  font-size: 21px;
  line-height: 34px;
  font-weight: 500;
  font-family: "Poppins";
  color: #43454d;

  @media (max-width: $grid-breakpoint-sm) {
    font-size: 18px;
  }
}

::v-deep h3 {
  font-size: 21px;
  line-height: 25px;
  font-family: "Poppins";
  color: #43454d;
  font-weight: 500;
}

.info-column {
  &:first-child {
    padding-right: 15px;

    @media (max-width: $grid-breakpoint-md) {
      padding-right: 5px;
    }
  }

  &+.info-column {
    padding-left: 15px;

    @media (max-width: $grid-breakpoint-md) {
      padding-left: 5px;
    }
  }
}

.edit-button {
  font-size: 14px;
  font-weight: 700;
  color: #007aa3;
  font-family: "Open Sans";
  border: none;
  background-color: transparent;
  cursor: pointer;
  margin-left: 12px;
  position: relative;
  bottom: 1px;
}
</style>
